import React from 'react';

import ArticleTeaser from './Teaser';
import ArticleDetail from './Detail';
import ArticleSmall from './Small';
import ArticleHighlighted from './Highlighted';

const NodeArticle = (props) => {
  const { viewMode } = props;

  switch (viewMode) {
    case 'teaser':
      return <ArticleTeaser {...props} />;
    case 'small':
      return <ArticleSmall {...props} />;
    case 'highlighted':
      return <ArticleHighlighted {...props} />;
    default:
      return <ArticleDetail {...props} />;
  }
};

export default NodeArticle;
